export default __webpack_public_path__ + "static/media/not_found.5eb3b492.svg";